import { useCookieConsent } from "../context/CookieConsentContext";
import usePosthogAnalytics from "../hooks/usePosthogAnalytics";
import useMetaPixel from "../hooks/useMetaPixel";

const ConsentAwareIntegrations = () => {
  const { preferences } = useCookieConsent();
  usePosthogAnalytics(preferences.analytics);
  useMetaPixel(preferences.marketing);
  return null;
};

export default ConsentAwareIntegrations;
